// This file is generated.
export var version = '1.52.0';
//# sourceMappingURL=version.js.map